"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ViewAction = void 0;

var React = _interopRequireWildcard(require("react"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _reactRedux = require("react-redux");

var _blocks = require("@bueno/blocks");

var _context = require("../context");

var _utils = require("../utils");

const Trigger = (0, _styledComponents.default)(_blocks.Button)`
  height: 22px;
  line-height: 18px;
  padding: 0 8px;
  transition: none;
  background: ${_blocks.palette.neutral8};

  &:active,
  &:focus {
    color: ${_blocks.color.pureWhite};
    text-decoration: none;
    background: ${_blocks.palette.neutral7};
  }
`;

const ViewActionComp = ({
  actionId,
  userDisplayName,
  onOpen
}) => {
  const {
    showModal
  } = (0, _context.useActions)();
  const handleOpen = React.useCallback(() => {
    showModal(actionId, userDisplayName);
    if (onOpen !== undefined) onOpen();
  }, [actionId, userDisplayName]);
  return /*#__PURE__*/React.createElement(Trigger, {
    onClick: handleOpen
  }, "#", (0, _utils.stripProjectPrefix)(actionId));
};

function mapStateToProps(state) {
  return {
    userDisplayName: state.auth.user.display_name
  };
}

const ViewAction = (0, _reactRedux.connect)(mapStateToProps)(ViewActionComp);
exports.ViewAction = ViewAction;